module.exports = __webpack_public_path__ + "img/abouttop.523b8793.jpg";